import React, { useState, useEffect, useMemo } from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import HelpIcon from '@material-ui/icons/HelpOutlineOutlined';
import DataTable from 'react-data-table-component';
const utils = require('../components/utils');

const baseUrl = `${window.nobid_endpoint}/carbon/pubreports_optimizer_pred`;

const columnsTopBidders = [
  { name: 'Publisher', selector: 'publisher_name', sortable: true },
  { name: '$Total Revenue', selector: 'revenue', sortable: true, cell: row => <span>{ utils.formatDouble(row.revenue) }</span>, definition: 'Revenue generated by the impression in the currency defined in the Prebid wrapper.' },
  { name: '$Revenue Excluded', selector: 'revenue_excluded', sortable: true, cell: row => <span>{ utils.formatDouble(row.revenue_excluded) }</span>, definition: 'Bid Requests will be blocked by the Auction Optimizer.' },
  { name: '%Revenue Excluded', selector: 'revenue_excluded_pct', sortable: true, cell: row => <span>{ utils.formatDouble(row.revenue_excluded_pct, '%') }</span>, definition: 'Bid Responses received over Bid Requests sent out.' },
  { name: '#Total Bid Requests', selector: 'bid_requests', sortable: true, cell: row => <span>{ utils.formatLong(row.bid_requests) }</span>, definition: 'Bid Requests will be blocked by the Auction Optimizer.' },
  { name: '#Bid Requests Excluded', selector: 'bid_requests_excluded', sortable: true, cell: row => <span>{ utils.formatLong(row.bid_requests_excluded) }</span>, definition: 'Bid Requests will be blocked by the Auction Optimizer.' },
  { name: '%Bid Requests Excluded', selector: 'bid_requests_excluded_pct', sortable: true, cell: row => <span>{ utils.formatDouble(row.bid_requests_excluded_pct, '%') }</span>, definition: 'Bid Responses received over Bid Requests sent out.' },
];
let dataTopBidders = [];
const DashboardOptimizerPredictiveAnalysisComponent = ({params, parentLoading}) => {
  const [loading, setLoading] = useState(true);

  const updateState = (results) => {
    const data = [];
    if (results) results.forEach( r => {
      data.push({publisher_name: r.publisher_name, revenue: r.revenue, revenue_excluded: r.revenue_excluded
      , revenue_excluded_pct: r.revenue_excluded_pct, bid_requests: r.bid_requests
      , bid_requests_excluded: r.bid_requests_excluded, bid_requests_excluded_pct: r.bid_requests_excluded_pct });
    });
    dataTopBidders = data;
    setLoading(false);
  }

  const getData = () => {
    setLoading(true);
    const p = params.filter(x => !x.startsWith('_sort=') && !x.startsWith('_end=') && !x.startsWith('_order='));
    p.push('_sort=revenue');
    p.push('_end=30');
    p.push('_order=DESC');
    p.push('show=publisher');
    let url = `${baseUrl}?${p.join('&')}`;
    let options = { headers: new Headers() };
    options.headers.set('accept', 'application/json');
    const token = localStorage.getItem('token');
    options.headers.set('Authorization', `Bearer ${token}`);
    fetch(url, options).then((response) => {
      return response.json();
    }).then((results) => {
      updateState(results);
    });
  }

  useEffect(() => { if (parentLoading) getData() }, [parentLoading]);
 
  return (
    <div style={{position: 'relative'}}>
      <div>
        <div style={{float: 'left', marginRight: '10px'}}>
        <Tooltip title={
        <React.Fragment>This analysis shows pre optimization impact. This analysis shows the percentage of bid requests 
          that the Optimizer is forecasted to block and the revenue impact.</React.Fragment>
        }>
          <HelpIcon/>
        </Tooltip>
        </div>
        <div style={{float: 'left'}}>
          <span style={{fontSize: '22px'}}>Optimization Predictive Analysis</span> <span style={{fontSize: '12px'}}>- based on the past 10 days performance including today</span>
        </div>
      </div>
      <DataTable
        noHeader={true}
        theme="dark"
        columns={columnsTopBidders}
        data={dataTopBidders}
        progressPending={loading}
        pagination
        fixedHeader
        paginationPerPage={10}
        paginationRowsPerPageOptions={[10, 20, 30, 50, 100]}
        dense
        highlightOnHover
      />
    </div>
  )
}

export default DashboardOptimizerPredictiveAnalysisComponent;
